export const downloadReport = (url, fileName = "report.pdf", targetWindow = "_blank") => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.target = targetWindow;
    link.click();
};